if (!customElements.get('details-custom')) {
    class DetailsComponent extends HTMLElement {
        constructor() {
            super();
            this.selector = this.dataset.selector;
            this.toggleBtns = this.querySelectorAll(`.js-toggle-detail`);

            if (this.toggleBtns) {
                this.bindEvents();
            }
        }
    
        bindEvents() {
            this.handleToggle();
        }
    
    
        handleToggle() {
            this.toggleBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.toggleBtns.forEach(el => {
                        if (el != btn) {
                            el.classList.remove('is-close')
                        }
                    });
    
                    btn.classList.toggle('is-close')
                });
            });
        }
    }
    customElements.define('details-custom', DetailsComponent);
}
  
